var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DxButton',{attrs:{"width":"100%","text":"SAVE","type":"success","styling-mode":"contained","validation-group":_vm.validationGroup},on:{"click":function($event){return _vm.onClick($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }